const lang = {
  uk: {
    courseName: "Тестовий курс",
    getAccess: "Отримати доступ",
    pay: "Сплатити",
    forOneLesson: "грн. за 1 урок",
    forThreeLessons: "грн. за 3 уроки",
    forFullCourse: "грн. за повний курс",
    oneNextLessonChosen:
      "Ви обрали придбати 1 наступний урок. Доступ буде відкрито до 12 уроку включно.",
    threeNextLessonsChosen:
      "Ви обрали придбати 3 наступні уроки. Доступ буде відкрито до 14 уроку включно.",
    fullCourseChosen:
      "Ви обрали придбати повний курс (32 уроки + 24 бонусних).",
    nextLesson: "«Ребус-метод». Наступний урок",
    threeNextLessons: "«Ребус-метод». Три наступні уроки",
    fullCourse: "«Ребус-метод». Повний курс, 32 уроки + 24 бонусних",
    fullCourseSpecialOffer:
      "«Ребус-метод». Повний курс, 32 уроки + 24 бонусних. Акційна ціна",
    paymentDetails: (orderNumber, phoneNumber) => `
    <h2>Деталі оплати</h2>
    <div class="payment-details">
      <dl class="definition-list">
        <div class="row"><dt>Отримувач:</dt> <dd>ФОП Жарков Юрій Маркович</dd></div>
        <div class="row"><dt>р/р:</dt> <dd>UA353220010000026008300008259</dd></div>
        <div class="row"><dt>код ЄДРПОУ:</dt> <dd>3007315235</dd></div>
        <div class="row"><dt>МФО:</dt> <dd>322001</dd></div>
        <div class="row"><dt>Банк:</dt> <dd>АТ «УНІВЕРСАЛ БАНК»</dd></div>
        <div class="row"><dt>Призначення платежу:</dt> <dd>Налаштування програмного забезпечення веб-сайту. Замовлення <strong id="order-number">№${orderNumber}</strong>.</dd></div>
      </dl>
      <p>Після оплати повідомте нас, і ми відкриємо доступ. За потреби, попросіть відкрити його до того, як кошти надійдуть на рахунок.<p>
      <p>Якщо у вас виникнуть питання або потрібна буде допомога, зверніться за номером <strong id="phone-number">${phoneNumber}</strong>.<p>
    </div>`,
  },
  en: {
    courseName: "Test course",
  },
};

export default lang["uk"];
